<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="discount-list-sidebar" position="left" lockedOpen="gt-md">
        <discount-list-sidebar></discount-list-sidebar>
    </fuse-sidebar>

    <!-- CENTER -->
    <div class="center">
        <div class="content-card" style="overflow-y: scroll;">
            <!-- CONTENT -->
            <div id="ngx-datatable" class="page-layout simple fullwidth docs">
                <div class="content p-24">
                    <ngx-datatable
                        #table
                        class="material"
                        [rows]="rows"
                        [loadingIndicator]="loadingIndicator"
                        [columnMode]="'force'"
                        [headerHeight]="48"
                        [footerHeight]="56"
                        [rowHeight]="'auto'"
                        [scrollbarH]="true"
                        [reorderable]="reorderable"
                        [selectionType]="'checkbox'"
                        [externalPaging]="true"
                        [count]="page.totalElements"
                        [offset]="page.pageNumber"
                        [limit]="page.size"
                        (page)="setPage($event)">


                        <ngx-datatable-column name="{{'Name' | translate}}" prop="name">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.name|translate}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Value' | translate}}" prop="name">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.value}} <span *ngIf="row.type==='percent'">%</span><span *ngIf="row.type==='value'">PLN</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Available date' | translate}}" prop="createdAt">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <span *ngIf="row.fromDate">{{row.fromDate | date:'dd.MM.yyyy':'UTC'}} </span>
                                    <span *ngIf="row.fromDate && row.toDate">-</span>
                                <span *ngIf="row.toDate">{{row.toDate | date:'dd.MM.yyyy':'UTC'}}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Created at' | translate}}" prop="createdAt">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.createdAt | date:'dd.MM.yyyy H:mm:ss':'UTC'}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Actions'|translate}}" sortable="true" prop="id">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <a routerLink="/settings/discounts/edit/{{row.id}}">{{'Edit'|translate}}</a>
                                <button
                                        mat-button
                                        class="mr-8"
                                        aria-label="Delete"
                                        color="warn"
                                        (click)="showConfirmDiscountDeleteDialog(row)"
                                >
                                    {{'Delete'|translate}}
                                </button>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>
        </div>
    </div>
</div>
